import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ProductCard from '../../components/ProductCard/ProductCard';
import './Wishlist.css';

const Wishlist = () => {
  const [wishlistItems, setWishlistItems] = useState([]);

  // Dummy products for empty wishlist state
  const dummyProducts = [
    {
      id: 'dummy1',
      title: 'EMPOWER SEAMLESS LEGGINGS',
      color: 'Black',
      price: 29.40,
      originalPrice: 42.00,
      discount: '30% OFF',
      frontImage: 'https://www.aybl.com/cdn/shop/files/AYBL_ECOM_31.03_Mixed4232.jpg?v=1744792855&width=400',
      backImage: 'https://www.aybl.com/cdn/shop/files/AYBL_ECOM_31.03_Mixed4236.jpg?v=1744792855&width=400',
      slug: 'empower-seamless-leggings-black',
      isDummy: true
    },
    {
      id: 'dummy2',
      title: 'STAPLE LEGGINGS',
      color: 'Black',
      price: 16.80,
      originalPrice: 20.00,
      discount: '40% OFF',
      frontImage: 'https://www.aybl.com/cdn/shop/files/The-Dutch-Oak-X-AYBL12229.jpg?v=1749829453&width=400',
      backImage: 'https://www.aybl.com/cdn/shop/files/The-Dutch-Oak-X-AYBL12243.jpg?v=1749829453&width=400',
      slug: 'staple-leggings-black',
      isDummy: true
    },
    {
      id: 'dummy3',
      title: 'ESSENTIAL OVERSIZED T SHIRT',
      color: 'Black',
      price: 16.80,
      originalPrice: 28.00,
      discount: '40% OFF',
      frontImage: 'https://www.aybl.com/cdn/shop/files/AYBL_ECOM_31.03_Mixed4232.jpg?v=1744792855&width=400',
      backImage: 'https://www.aybl.com/cdn/shop/files/AYBL_ECOM_31.03_Mixed4236.jpg?v=1744792855&width=400',
      slug: 'essential-oversized-tshirt-black',
      isDummy: true
    }
  ];

  useEffect(() => {
    // Load wishlist items from localStorage
    const savedWishlist = localStorage.getItem('wishlist');
    if (savedWishlist) {
      try {
        const parsedWishlist = JSON.parse(savedWishlist);
        setWishlistItems(parsedWishlist);
      } catch (error) {
        console.error('Error parsing wishlist from localStorage:', error);
        setWishlistItems([]);
      }
    }
  }, []);

  // Function to remove item from wishlist
  const removeFromWishlist = (productId) => {
    const updatedWishlist = wishlistItems.filter(item => item.id !== productId);
    setWishlistItems(updatedWishlist);
    localStorage.setItem('wishlist', JSON.stringify(updatedWishlist));
  };

  // Determine which products to display
  const displayProducts = wishlistItems.length > 0 ? wishlistItems : dummyProducts;

  return (
    <div className="wishlist-page">
      <div className="wishlist-container">
        {/* Page Header */}
        <div className="wishlist-header">
          <h1>WISHLIST</h1>
        </div>

        {/* Products Grid */}
        <div className="wishlist-products">
          {displayProducts.map((product) => (
            <ProductCard 
              key={product.id} 
              product={product}
              isInWishlist={wishlistItems.some(item => item.id === product.id)}
              onWishlistToggle={() => {
                if (product.isDummy) {
                  // For dummy products, add to wishlist
                  const newWishlistItem = {
                    ...product,
                    isDummy: false,
                    addedAt: new Date().toISOString()
                  };
                  const updatedWishlist = [...wishlistItems, newWishlistItem];
                  setWishlistItems(updatedWishlist);
                  localStorage.setItem('wishlist', JSON.stringify(updatedWishlist));
                } else {
                  // For real wishlist items, remove from wishlist
                  removeFromWishlist(product.id);
                }
              }}
            />
          ))}
        </div>

        {/* Empty State Message (only show if no wishlist items and not showing dummy products) */}
        {wishlistItems.length === 0 && (
          <div className="empty-wishlist-message">
            <p>Your wishlist is empty. Add some products to get started!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Wishlist; 